export default "__VITE_ASSET__BL7suuuT__"